import { Action } from '@ngrx/store';

export enum HaccpActions {

    GetTypeProcedure = '[Haccp] Get Type Procedure',
    GetTypeProcedureSuccess = '[Haccp] Get Type Procedure Success',
    GetTypeProcedureError = '[Haccp] Get Type Procedure Error',
    GetTypeRecord = '[Haccp] Get Record Procedure',
    GetTypeRecordSuccess = '[Haccp] Get Type Record Success',
    GetTypeRecordError = '[Haccp] Get Type Record Error',
    GetHazardType = '[Haccp] Get Hazard Type',
    GetHazardTypeSuccess = '[Haccp] Get Hazard Type Success',
    GetHazardTypeError = '[Haccp] Get Hazard Type Error',
    AddHazardType = '[Haccp] Add Hazard Type',
    AddHazardTypeSuccess = '[Haccp] Add Hazard Type Success',
    AddHazardTypeError = '[Haccp] Add Hazard Type Error',
    CreateHazard = '[Haccp] Create Hazard',
    CreateHazardSuccess = '[Haccp] Create Hazard Success',
    CreateHazardError = '[Haccp] Create Hazard Error',
    GetAllHazards = '[Haccp] Get All Hazards',
    GetAllHazardsSuccess = '[Haccp] Get All Hazards Success',
    GetAllHazardsError = '[Haccp] Get All Hazards Error',
    GetHazardById = '[Haccp] Get Hazard By Id',
    GetHazardByIdSuccess = '[Haccp] Get Hazard By Id Success',
    GetHazardByIdError = '[Haccp] Get Hazard By Id Error',
    HazardSearch = '[Haccp] Hazard Search',
    HazardSearchSuccess = '[Haccp] Hazard Search Success',
    HazardSearchError = '[Haccp] Hazard Search Error',
    GetHazardCount='[Haccp] Get Hazard Count',
    GetHazardCountSuccess='[Haccp] Get Hazard Count Success',
    GetHazardCountError='[Haccp] Get Hazard Count Error',
    EditHazard = '[Hazard] Edit Hazard',
    GetEditHazardSuccess = '[Hazard] Get Edit Hazard Success',
    GetEditHazardError = '[] Get Edit Hazard Error',
}


export class GetTypeProcedure implements Action {
    public readonly type = HaccpActions.GetTypeProcedure;
    constructor(public payload: any) {

    }
}
export class GetTypeProcedureSuccess implements Action {
    public readonly type = HaccpActions.GetTypeProcedureSuccess;
    constructor(public payload: any) {

    }
}
export class GetTypeProcedureError implements Action {
    public readonly type = HaccpActions.GetTypeProcedureError;
    constructor(public payload: any) {

    }
}
export class GetTypeRecord implements Action {
    public readonly type = HaccpActions.GetTypeRecord;
    constructor(public payload: any) {
    }
}
export class GetTypeRecordSuccess implements Action {
    public readonly type = HaccpActions.GetTypeRecordSuccess;
    constructor(public payload: any) {
    }
}
export class GetTypeRecordError implements Action {
    public readonly type = HaccpActions.GetTypeRecordError;
    constructor(public payload: any) {

    }
}
export class GetHazardType implements Action {
    public readonly type = HaccpActions.GetHazardType;
    constructor(public payload: any) {
    }
}
export class GetHazardTypeSuccess implements Action {
    public readonly type = HaccpActions.GetHazardTypeSuccess;
    constructor(public payload: any) {

    }
}
export class GetHazardTypeError implements Action {
    public readonly type = HaccpActions.GetHazardTypeError;
    constructor(public payload: any) {

    }
}
export class AddHazardType implements Action {
    public readonly type = HaccpActions.AddHazardType;
    constructor(public payload: any) {

    }
}
export class AddHazardTypeSuccess implements Action {
    public readonly type = HaccpActions.AddHazardTypeSuccess;
    constructor(public payload: any) {

    }
}
export class AddHazardTypeError implements Action {
    public readonly type = HaccpActions.AddHazardTypeError;
    constructor(public payload: any) {

    }
}
export class CreateHazard implements Action {
    public readonly type = HaccpActions.CreateHazard;
    constructor(public payload: any) {

    }
}
export class CreateHazardSuccess implements Action {
    public readonly type = HaccpActions.CreateHazardSuccess;
    constructor(public payload: any) {

    }
}
export class CreateHazardError implements Action {
    public readonly type = HaccpActions.CreateHazardError;
    constructor(public payload: any) {

    }
}
export class GetAllHazards implements Action {
    public readonly type = HaccpActions.GetAllHazards;
    constructor(public payload: any) {

    }
}
export class GetAllHazardsSuccess implements Action {
    public readonly type = HaccpActions.GetAllHazardsSuccess;
    constructor(public payload: any) {

    }
}
export class GetAllHazardsError implements Action {
    public readonly type = HaccpActions.GetAllHazardsError;
    constructor(public payload: any) {

    }
}
export class GetHazardById implements Action {
    public readonly type = HaccpActions.GetHazardById;
    constructor(public payload: any) {

    }
}
export class GetHazardByIdSuccess implements Action {
    public readonly type = HaccpActions.GetHazardByIdSuccess;
    constructor(public payload: any) {

    }
}
export class GetHazardByIdError implements Action {
    public readonly type = HaccpActions.GetHazardByIdError;
    constructor(public payload: any) {

    }
}

export class GetHazardCount implements Action {
    public readonly type = HaccpActions.GetHazardCount;
    constructor(public payload: any) {
    }
}
export class GetHazardCountSuccess implements Action {
    public readonly type = HaccpActions.GetHazardCountSuccess;
    constructor(public payload: any) {
    }
}
export class GetHazardCountError implements Action {
    public readonly type = HaccpActions.GetHazardCountError;
    constructor(public payload: any) {
    }
}

export class HazardSearch implements Action {
    public readonly type = HaccpActions.HazardSearch;
    constructor(public payload: any,public title:any) {
    }
}
export class HazardSearchSuccess implements Action {
    public readonly type = HaccpActions.HazardSearchSuccess;
    constructor(public payload: any) {
    }
}
export class HazardSearchError implements Action {
    public readonly type = HaccpActions.HazardSearchError;
    constructor(public payload: any) {
    }
}

export class EditHazard implements Action {
    public readonly type = HaccpActions.EditHazard;
    constructor(public payload: any, public param: any) {
    }
}
export class GetEditHazardSuccess implements Action {
    public readonly type = HaccpActions.GetEditHazardSuccess;
    constructor(public payload: any) {

    }
}
export class GetEditHazardError implements Action {
    public readonly type = HaccpActions.GetEditHazardError;
    constructor(public payload: any) {

    }
}


export type HaccpAction = GetTypeProcedure | GetTypeProcedureSuccess | GetTypeProcedureError | GetTypeRecord |
    GetTypeRecordSuccess | GetTypeRecordError| GetHazardType| GetHazardTypeSuccess| GetHazardTypeError|
    AddHazardType |AddHazardTypeSuccess |AddHazardTypeError| CreateHazard| CreateHazardSuccess| CreateHazardError|
    GetAllHazards| GetAllHazardsSuccess| GetAllHazardsError| GetHazardById| GetHazardByIdSuccess|GetHazardByIdError |
    GetHazardCount | GetHazardCountSuccess| GetHazardCountError | HazardSearch |HazardSearchSuccess |HazardSearchError
    |EditHazard |GetEditHazardSuccess |GetEditHazardError;
